import { jsonBaseURI } from '@st-graphics/graphics-kit/urls'
import { convertToLowercase } from '$utils'
import { copyJson, sheetJson, introJson } from '$state/data'

/**
 * Google Document ID
 *
 * Example:
 * https://docs.google.com/document/d/1CEbzz-SimxhJoz028yYdBnkhnsfAfe2mu1gW-F5VuDI/edit?tab=t.0
 *
 * Document/Copy ID: 1CEbzz-SimxhJoz028yYdBnkhnsfAfe2mu1gW-F5VuDI
 *
 */
const copyId = '1yAj1_a5kXZfFV2HLOgb71doqWVMn9gCd-rlIPlUj7dA'

/**
 * Google Spreadsheet ID + Sheet ID (GID)
 *
 * Example:
 * https://docs.google.com/spreadsheets/d/1pyCLx7KmtlWywN_2o4C-1hCsGNCIMsrGe8-0Msjs1G8/edit?gid=0#gid=0
 *
 * Spreadsheet ID: 1pyCLx7KmtlWywN_2o4C-1hCsGNCIMsrGe8-0Msjs1G8
 * Sheet ID (GID): 0
 *
 * Sheet Id = '1pyCLx7KmtlWywN_2o4C-1hCsGNCIMsrGe8-0Msjs1G8/0'
 *
 */
const btoLinks = {
  sheet: '1haceve4DPrnaFareD-n1LKL0E23_QSuW5sohnkUhFAo/691857021',
  //sheet: '1w_Gt4E72dGq8swkeFHfAHGLPhxqJWB8SyCnG3d2VVF0/691857021',
  intro: '1haceve4DPrnaFareD-n1LKL0E23_QSuW5sohnkUhFAo/400777319',
}

/** @type {import('./$types').PageLoad} */
export async function load({ fetch }) {
  if (copyId && copyId != '') {
    const url = `${jsonBaseURI}/${copyId}.json`

    // Fetch all data sources in parallel to eliminate sequential loading delay
    const [response, sheetResponse, introResponse] = await Promise.all([
      fetch(url),
      btoLinks.sheet && btoLinks.sheet !== ''
        ? fetch(`${jsonBaseURI}/${btoLinks.sheet}.json`)
        : Promise.resolve(null),
      btoLinks.intro && btoLinks.intro !== ''
        ? fetch(`${jsonBaseURI}/${btoLinks.intro}.json`)
        : Promise.resolve(null),
    ])

    const json = await response.json()
    copyJson.data = json

    if (sheetResponse) {
      sheetJson.data = await sheetResponse.json()
    }

    if (introResponse) {
      introJson.data = await introResponse.json()
    }

    return { copyId, ...convertToLowercase(json) }
  }
}
